export const registrationOptions = [
    { value: 'inmatriculat', label: 'înmatriculat'},
    { value: 'in vederea inmatricularii', label: 'în vederea înmatriculării'},
];

export const initValidStateValue = {help: '', field: '', error: false};

export const categoriePJOptions = [
    { value: 'SC nefinanciare - S.R.L.', label: 'SRL' },
    { value: 'SC nefinanciare - P.F.A.', label: 'PFA' },
    { value: 'SC nefinanciare - P.F.I.', label: 'PFI' },
    { value: 'SC nefinanciare - S.A.', label: 'Societate pe acțiuni' },
    { value: 'banci si cooperative de credit', label: 'Bănci/ Cooperative de credit' },
    { value: 'intermediari financiari - leasing', label: 'Intermediari financiari/ Leasing' },
    { value: 'alti intermediari financiari', label: 'Alți intermediari financiari' },
    { value: 'institutii guvernamentale', label: 'Instituții guvernamentale' },
    { value: 'regii autonome', label: 'Regii autonome' },
    { value: 'alte SC nefinanciare', label: 'Altă societate nefinanciară' },
];
